<ps-ui-modal size="lg">
  <h5 psUiModalTitle class="select-buyer-header">Select Buyer Entity</h5>
  <ps-ui-modal-body>
    <div>
      <p class="multi-buyer-title">
        Select the Buyer Entity that you will operate as
      </p>
    </div>
    <div class="select-buyer">
      <ps-ui-select-dropdown
        labelNone="Choose Entity ..."
        [multi]="false"
        [dropdownItems]="multiBuyersCmpsList"
        [field]="'nm'"
        [(ngModel)]="selectedCompany"
        [orderBy]="'nm'"
      >
      </ps-ui-select-dropdown>
      <i
        class="fa fa-times-circle clear"
        *ngIf="multiBuyersCmpsList.length && selectedCompany"
        (click)="clearBuyer()"
      >
      </i>
    </div>
    <button psUiButton class="confirm-buyer" (click)="setBuyerDetails()">
      Confirm
    </button>
  </ps-ui-modal-body>
</ps-ui-modal>
